<template>
  <div>
    <Modal
      v-model="serverSelectModal"
      title="选择服务器"
      width="1000">
      <div style="text-align: left">
        <RadioGroup v-model="selectType">
          <Radio label="server">常规选择</Radio>
          <Radio label="group" v-if="!single">从分组选择</Radio>
        </RadioGroup>
      </div>
      <ul v-show="selectType === 'group'" id="execServerGroupZTree" class="ztree"></ul>
      <Divider />
      <div>
        <span>已选服务器(<b>{{ selectRow.length }}</b>)：<a v-on:click="emptyServer" v-if="selectRow.length">清空 </a> </span>
        <Tag color="primary" closable v-for="(item, index) in selectRow" :key="'hostname_' + index" @on-close="removeServer('remove', item)">{{ item }}</Tag>
      </div>
      <Divider />
      <Form inline :label-width="50" ref="searchServerForm" :model="searchServerForm">
        <FormItem label="主机名">
          <Input v-model="searchServerForm.hostname" @on-enter="getServers()" placeholder="过滤主机名"/>
        </FormItem>
        <FormItem label="公网IP">
          <Input v-model="searchServerForm.public_ip" @on-enter="getServers()" placeholder="过滤公网IP"/>
        </FormItem>
        <FormItem label="内网IP">
          <Input v-model="searchServerForm.inner_ip" @on-enter="getServers()" placeholder="过滤内网IP"/>
        </FormItem>
        <FormItem :label-width="0" class="mob-align-right">
          <Button type="primary" @click="getServers()" style="margin-right: 8px">搜索</Button>
          <Button @click="resetServerSearchForm">重置</Button>
        </FormItem>
      </Form>
      <Alert v-if="serverError" type="warning" show-icon>获取服务器列表失败</Alert>
      <div v-else>
        <Alert show-icon>提示！无法选择未填写主机名的服务器！</Alert>
        <Table
          ref="serverTable"
          :loading="serverTableLoading"
          :data="server.data"
          size="small"
          @on-sort-change="sortChange"
          :columns="server.columns">
        </Table>
        <div style="margin: 10px 0; overflow: hidden;">
          <div style="float: left;">
            当前显示 {{ server.data.length }} 条记录，总共 {{ server.count }} 条记录
          </div>
          <div style="float: right;">
            <page :total="server.count" :current="server.page" :page-size="server.size" @on-change="getServers"></page>
          </div>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" style="margin-right: 8px" @click="selectServerOk">确定</Button>
        <Button @click="serverSelectModal = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getOpsCenterServer, getOpsCenterServerGroup,
  getOpsCenterAllServer } from '@/api/opscenter'
import { getJsonLength } from './scriptTools'
export default {
  name: 'select-server',
  data () {
    return {
      // 选择目标服务器
      serverError: false,
      serverSelectModal: false,
      single: false,
      selected: [],
      selectType: 'server',
      searchServerForm: {
        hostname: '',
        public_ip: '',
        inner_ip: '',
        ordering: ''
      },
      assetParams: {},
      server: {
        data: [],
        columns: [
          {
            title: '选中',
            align: 'center',
            minWidth: 60,
            key: 'checkBox',
            render: (h, params) => {
              let disabled = false
              if (!params.row.hostname) {
                disabled = true
              }
              let isCheck = false
              if (this.selectRow.indexOf(params.row.hostname) > -1) {
                isCheck = true
              }
              return h('div', [
                h('Checkbox', {
                  props: {
                    value: isCheck,
                    disabled: disabled
                  },
                  on: {
                    'on-change': (e) => {
                      this.server.data[params.index].checkBox = e
                      if (e) {
                        if (this.single) {
                          this.emptyServer()
                        }
                        if (this.selectRow.indexOf(params.row.hostname) < 0) {
                          this.selectRow.push(params.row.hostname)
                          this.selectServerIds[params.row.hostname] = params.row.id
                        }
                      } else {
                        this.removeServer(null, params.row.hostname)
                      }
                    }
                  }
                })
              ])
            }
          },
          {
            minWidth: 160,
            title: '主机名',
            tooltip: true,
            align: 'center',
            sortable: 'custom',
            key: 'hostname',
            render: (h, params) => {
              if (params.row.hostname) {
                return h('div', params.row.hostname)
              } else {
                return h('div', '未填主机名,不能选择')
              }
            }
          },
          {
            minWidth: 130,
            title: '公网IP',
            align: 'center',
            sortable: 'custom',
            key: 'public_ip'
          },
          {
            minWidth: 130,
            title: '私有IP',
            align: 'center',
            sortable: 'custom',
            key: 'inner_ip'
          },
          {
            minWidth: 100,
            title: '操作系统',
            sortable: 'custom',
            align: 'center',
            key: 'os',
            render: (h, params) => {
              let k = { 0: 'Linux', 1: 'Windows' }
              if (params.row.os === 0 || params.row.os === 1) {
                return h('div', k[params.row.os])
              } else {
                return ''
              }
            }
          },
          {
            minWidth: 120,
            title: '已安装Agent',
            key: 'troop_status',
            align: 'center',
            render: (h, params) => {
              const row = params.row
              const text = row.troop_status ? '是' : '否'

              return h('span', {
                style: {
                  color: row.troop_status ? '#19be6b' : ''
                }
              }, text)
            }
          }
          // {
          //   minWidth: 120,
          //   title: '状态',
          //   align: 'center',
          //   sortable: 'custom',
          //   key: 'status',
          //   render: (h, params) => {
          //     const row = params.row
          //     const color = row.status === 0 || row.status === -1 ? 'error' : row.status === 1 ? 'success' : 'warning'
          //     const text = row.status === 0 || row.status === -1 ? '断开' : row.status === 1 ? '运行' : '未知'
          //     return h('Tag', {
          //       props: {
          //         type: 'dot',
          //         color: color
          //       }
          //     }, text)
          //   }
          // }
        ],
        count: 0,
        page: 1,
        size: 5
      },
      serverTableLoading: false,
      selectRow: [],
      selectServerIds: {},
      endSelectServer: {},
      endSelectServerLength: 0,
      id: '',
      // 服务器组
      zTreeSetting: {
        view: {
          selectedMulti: false
        },
        data: {
          simpleData: {
            enable: true,
            idKey: 'id',
            pIdKey: 'parent_id',
            rootPId: 0
          }
        },
        check: {
          enable: false
        },
        callback: {
          onClick: this.zTreeOnClick,
          onRightClick: this.OnRightClick
        }
      },
      zTree: '',
      zNodes: [{ 'id': 0, 'parent_id': 0, 'name': '所有主机', 'open': 'true' }]
    }
  },
  methods: {
    // 打开服务器选择Modal
    openSelectServerModal (assetParams = {}, selectedServer = {}, id = '', single = false) {
      this.id = id
      this.assetParams = assetParams
      this.getServers()
      this.getServerGroup()
      this.selectServerIds = {}
      this.selectRow = []
      this.single = single
      for (let hostname in selectedServer) {
        if (selectedServer[hostname]) {
          this.selectRow.push(hostname)
          this.selectServerIds[hostname] = selectedServer[hostname]
        }
      }
      this.serverSelectModal = true
    },
    // 获取服务器分组列表
    getServerGroup () {
      this.zNodes = [{ 'id': 0, 'parent_id': 0, 'name': '所有主机', 'open': 'true' }]
      getOpsCenterServerGroup().then(res => {
        this.zNodes = this.zNodes.concat(res.data)
        this.zTreeInit()
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取服务器分组失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    // zTree初始化
    zTreeInit () {
      this.zTree = $.fn.zTree.init($('#execServerGroupZTree'), this.zTreeSetting, this.zNodes)
    },
    // 点击服务器列表
    zTreeOnClick (event, treeId, treeNode) {
      let idIn = ''
      if (treeNode.id !== 0) {
        let childNodes = this.getChildNodes(treeNode)
        if (childNodes) {
          idIn = childNodes
        } else {
          idIn = 99999999
        }
      }
      this.emptyServer()
      getOpsCenterAllServer({ id__in: idIn }).then(res => {
        let result = res.data
        for (let i in result) {
          if (result[i].hostname) {
            this.selectRow.push(result[i].hostname)
            this.selectServerIds[result[i].hostname] = result[i].id
          }
        }
        this.getServers(this.server.page)
      })
    },
    // 获取子Nodes
    getChildNodes (treeNode) {
      let childNodes = this.zTree.transformToArray(treeNode)
      let nodes = []
      for (let i = 0; i < childNodes.length; i++) {
        if (childNodes[i].server) {
          nodes = nodes.concat(childNodes[i].server.split(','))
        }
      }
      console.log(nodes.join(','))
      return nodes.join(',')
    },
    // 获取服务器列表和存活状态
    getServers (value = 1) {
      this.server.page = value
      this.serverTableLoading = true
      this.searchServerForm['size'] = this.server.size
      this.searchServerForm['page'] = this.server.page
      for (let p in this.assetParams) {
        this.searchServerForm[p] = this.assetParams[p]
      }
      this.serverError = false
      getOpsCenterServer(this.searchServerForm).then(res => {
        let result = res.data
        let tableData = result.results
        this.server.count = result.count

        this.server.data = tableData
        this.serverTableLoading = false
        // let hostnames = []
        // for (let i in result.results) {
        //   if (result.results[i].hostname) {
        //     hostnames.push(result.results[i].hostname)
        //   }
        // }
        // let reqParams = {
        //   'hostnames': hostnames,
        //   'counters': ['agent.alive']
        // }
        // getBaseMonitorOne(reqParams).then(monitorRes => {
        //   let MonitorDataResult = monitorRes.data
        //   if (MonitorDataResult.code === 200) {
        //     for (let l in tableData) {
        //       let hostname = tableData[l].hostname
        //       let agentAlive = 0
        //       let timestamp = ''
        //       if (hostname) {
        //         if (MonitorDataResult.data[hostname]['timestamp']) {
        //           agentAlive = MonitorDataResult.data[hostname]['agent.alive']
        //           timestamp = MonitorDataResult.data[hostname]['timestamp']
        //         }
        //       }
        //       tableData[l]['status'] = agentAlive
        //       tableData[l]['timestamp'] = timestamp
        //     }
        //   }
        //   this.server.data = tableData
        //   this.serverTableLoading = false
        // }).catch(res => {
        //   this.server.data = tableData
        //   this.serverTableLoading = false
        // })
      }).catch(res => {
        this.serverError = true
        this.serverTableLoading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取主机列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    // 重置搜索表单
    resetServerSearchForm () {
      this.searchServerForm = {
        hostname: '',
        public_ip: '',
        inner_ip: ''
      }
      this.getServers()
    },
    // 移除选中的服务器
    removeServer (event, name) {
      if (event) {
        for (let i in this.server.data) {
          if (this.server.data[i].hostname === name) {
            this.server.data[i].checkBox = false
            break
          }
        }
      }
      const index = this.selectRow.indexOf(name)
      this.selectRow.splice(index, 1)
      this.selectServerIds[name] = null
    },
    // 清空选中的服务器
    emptyServer () {
      this.selectServerIds = {}
      for (let i in this.server.data) {
        this.server.data[i].checkBox = false
      }
      this.selectRow = []
    },
    // 选择服务器完成
    selectServerOk () {
      this.endSelectServer = {}
      for (let hostname in this.selectServerIds) {
        if (this.selectServerIds[hostname]) {
          this.endSelectServer[hostname] = this.selectServerIds[hostname]
        }
      }
      this.selectServerIds = {}
      this.selectRow = []
      this.endSelectServerLength = getJsonLength(this.endSelectServer)
      this.serverSelectModal = false
      this.$emit('selectServerComplete', this.endSelectServer, this.endSelectServerLength, this.id)
    },
    // 排序
    sortChange (params) {
      if (params.order === 'asc') {
        this.searchServerForm.ordering = params.key
      } else if (params.order === 'desc') {
        this.searchServerForm.ordering = '-' + params.key
      } else {
        this.searchServerForm.ordering = ''
      }
      this.getServers()
    }
  }
}
</script>

<style>
  @import '../../plugin/ztree/css/metroStyle/metroStyle.css';
  #rMenu {
    position:absolute;
    visibility:hidden;
    top:0;
    background-color: #555;
    text-align: left;
    padding: 2px;
  }
  #rMenu a{
    padding: 3px 15px 3px 15px;
    cursor: pointer;
    list-style: none outside none;
  }
  .list-group-item {
    position: relative;
    display: block;
    padding: 10px 15px;
    margin-bottom: -1px;
    background-color: #fff;
    border: 1px solid #ddd;
  }
</style>
